var rules = require('./data/rules')
var webviewRegExp = new RegExp('(' + rules.join('|') + ')', 'ig')

module.exports = function isWebview(ua) {
  return !!ua.match(webviewRegExp)
}



//////////////////
// WEBPACK FOOTER
// ../~/is-ua-webview/index.js
// module id = 1034
// module chunks = 0